import { useEffect, useState } from 'react'
import { Dropdown } from 'primereact/dropdown'
import './page-dropdown.scss'

export default function PageDropdown({ options, selectedValue, onChange, className, name, placeholder,disabled,errors,loading }) {
  const [newOption,setNewOption] = useState(options)
  useEffect(() => {
  
      setNewOption(options)
    
  }, [options])
  
  return (
    <div className='card flex justify-content-center pdropdown'>
      <Dropdown
        loading={loading}
        value={selectedValue}
        onChange={onChange}
        options={newOption}
        optionLabel='label'
        className={className}
        name={name}
        placeholder={placeholder}
        style={{borderColor:  errors != undefined && errors != null && errors[name] ? 'red' : ''}}
        {...(disabled && { disabled })}
      />
    </div>
  )
}
